<template>
    <div>
        <div  v-if="getSelectedEvent">
            <div v-if="user && isEventToday(getSelectedEvent[0].start_date, getSelectedEvent[0].end_date, getSelectedEvent[0].eventSwitchTime, getEventSwitchTime)" >
                <h3 v-if="user && user.corporation && user.corporation.showShoeMotif === 2">Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous incognito mode</h3>
                <h3 v-else>Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode.</h3>
                <br><br>
                <button :style="styleObjectByName" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)" type="button" @click="joinEvent('0')" title="Join event with your first name">{{user.firstName}}</button>
                <button :style="styleObjectCognito" @mouseenter="updateHoverStateCog(true)" @mouseleave="updateHoverStateCog(false)" type="button" @click="joinEvent('1')" :title= "user && user.corporation && user.corporation.showShoeMotif === 2 ? 'Join event as incognito' : 'Join event as shoe-cognito'">{{cognitoMsg}}</button>
            </div>
            <div v-if="user && !isEventToday(getSelectedEvent[0].start_date, getSelectedEvent[0].end_date, getSelectedEvent[0].eventSwitchTime, getEventSwitchTime)" >
                <!--<h2>Hey, {{user.firstName}}. Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.-->
                <!--<br>How you would like to join the conversation?-->
                <!--</h2>-->
                <h3 v-if="user && user.corporation && user.corporation.showShoeMotif === 2">This event will start {{getDateReference(getSelectedEvent[0].start_date, 'live2')}}. Check back on this page <span v-if="getSelectedEvent[0].eventSwitchTime && getSelectedEvent[0].eventSwitchTime > 0" :style="{color: getCorpHeadingColor + ' !important'}"> {{getSelectedEvent[0].eventSwitchTime}} </span><span v-else :style="{color: getCorpHeadingColor + ' !important'}">{{getEventSwitchTime}}</span> minutes before the event start time and choose how you want to join the event. <br>You can join as yourself or step into someone else's shoes using our anonymous incognito mode.</h3>
                <h3 v-else>This event will start {{getDateReference(getSelectedEvent[0].start_date, 'live2')}}. Check back on this page <span v-if="getSelectedEvent[0].eventSwitchTime && getSelectedEvent[0].eventSwitchTime > 0" :style="{color: getCorpHeadingColor + ' !important'}"> {{getSelectedEvent[0].eventSwitchTime}} </span><span v-else :style="{color: getCorpHeadingColor + ' !important'}">{{getEventSwitchTime}}</span> minutes before the event start time and choose how you want to join the event. <br>You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode.</h3>
                <br>
                <br>
                <button type="button" disabled @click="joinEvent('0')" title="Event hasn't started yet">{{user.firstName}}</button>
                <button type="button" disabled @click="joinEvent('1')"title="Event hasn't started yet"><span v-if="user && user.corporation && user.corporation.showShoeMotif === 2">Incognito</span><span v-else>shoe-cognito</span></button>
            </div>
            <div v-if="!user && isEventToday(getSelectedEvent[0].start_date, getSelectedEvent[0].end_date, getSelectedEvent[0].eventSwitchTime, getEventSwitchTime)">
                <!--<h3>Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode</h3>-->
                <!--<br>-->
                <!--<br>-->
                <button :style="styleObjectByName" @mouseenter="updateHoverState(true)" @mouseleave="updateHoverState(false)"type="button" @click="joinEventUnAuth(getSelectedEvent[0])" title="Login or Signup to join the event">Go to Event</button>
            </div>
            <div v-if="!user && !isEventToday(getSelectedEvent[0].start_date, getSelectedEvent[0].end_date, getSelectedEvent[0].eventSwitchTime, getEventSwitchTime)">
<!--                <h3>This event will start {{getDateReference(getSelectedEvent[0].start_date, 'live2')}}. Check back on this page <span v-if="getSelectedEvent[0].eventSwitchTime && getSelectedEvent[0].eventSwitchTime > 0" :style="{color: getCorpHeadingColor + ' !important'}"> {{getSelectedEvent[0].eventSwitchTime}} </span><span v-else :style="{color: getCorpHeadingColor + ' !important'}">{{getEventSwitchTime}}</span> minutes before the event start time and select <br> Go to Event</h3>-->
                <h3>This event will start {{getDateReference(getSelectedEvent[0].start_date, 'live2')}}. <a v-a11y-action href="javascript:" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" @click="UnauthSignInClick(getSelectedEvent[0])">Sign In</a> or <a v-a11y-action href="javascript:" v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" @click="UnauthJoinClick(getSelectedEvent[0])">Sign Up</a> to join us for a discussion that will inspire and empower you to be the best version of yourself.</h3>
                <br>
                <br>
<!--                <button type="button"  disabled @click="" title="Event hasn't started yet">Go to Event</button>-->
                <button type="button" @click="UnauthJoinClick(getSelectedEvent[0])" class="sigup-green-join-button">{{trialButtonTitle}}</button>
            </div>
            <div>
                Please follow the event guidelines:
                <span v-bind:style="{ color: getCorpHeadingColor + ' !important'}">1.)</span> Keep it positive, supportive and respectful;
                <span v-bind:style="{ color: getCorpHeadingColor + ' !important'}">2.)</span> Please be thoughtful and stay on topic;
                <span v-bind:style="{ color: getCorpHeadingColor + ' !important'}">3.)</span> Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;
                <span v-bind:style="{ color: getCorpHeadingColor + ' !important'}">4.)</span > Please refer to TONE's <a v-bind:style="{ color: $a11yInkColor(getCorpHeadingColor) + ' !important'}" href="/terms" target="new" title="click to view our terms">Terms of Service</a> for more information.
            </div>
            <!---->
            <!--<div v-if="isEventToday(getSelectedEvent[0].start_date, getSelectedEvent[0].end_date)">-->
            <!--&lt;!&ndash;<div v-if="isEventToday(getSelectedEvent[0].start_date) === false">&ndash;&gt;-->
            <!--<h2>Hey, {{user.firstName}}. Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.-->
            <!--<br>How you would like to join the conversation?-->
            <!--</h2>-->
            <!--<button type="button" @click="joinEvent('0')">{{user.firstName}}</button>-->
            <!--<button type="button" @click="joinEvent('1')">Shoe-cognito</button>-->
            <!--</div>-->
            <!--<div v-else>-->
            <!--<h2>Hey, {{user.firstName}}. Welcome to our community of women helping women, featuring TONE Talks moderated discussions and TONE Live streaming events with our experts.-->
            <!--</h2>-->
            <!--<h2>Event will start here at <br> {{getDateReference(getSelectedEvent[0].start_date, 'live2')}}</h2>-->
            <!--</div>-->
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { dateHelpers } from '../helpers/dateHelpers.js'
    import store from '../store'
    export default {
        name: 'rulescomp',
        props: ['data'],
        data: function () {
            return {
                trialButtonTitle: 'Start Your Free Trial',
                hoverState: false,
                hoverStateCog: false,
                congnitoMsg: '',
                eventRef: null,
                event: '',
                userEvent: '',
                showRulesComp: false,
                seatReservation: {
                    userEventId: 0,
                    eventId: 0,
                    userId: 0,
                    status: 2,
                    isAnonymous: 0
                }
            }
        },
        methods: {
            updateHoverState (isHover) {
                this.hoverState = isHover
            },
            updateHoverStateCog (isHover) {
                this.hoverStateCog = isHover
            },
            UnauthJoinClick (event) {
                let joinString = `/event/${event.eventId}`
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', joinString)
                } else {
                    sessionStorage.setItem('redirectPath', joinString)
                }
                this.$router.push('/signup')
                // store.commit('setTriggerLogin', {loginStatus: true})
            },
            UnauthSignInClick (event) {
                let joinString = `/event/${event.eventId}`
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', joinString)
                } else {
                    sessionStorage.setItem('redirectPath', joinString)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
            },
            joinEventUnAuth (event) {
                let joinString = `/event/${event.eventId}`
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', joinString)
                } else {
                    sessionStorage.setItem('redirectPath', joinString)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
                // this.$router.push(`/rules/` + event.eventId)
            },
            joinEvent (isAnonymous) {
                console.log('1 -> RulesComp.vue -> joinEvent() -> isAnonymous = ', isAnonymous)
                this.updateUserStatus(isAnonymous)
                if (this.getSelectedEvent) {
                    console.log('2 -> RulesComp.vue -> joinEvent() -> this.getSelectedEvent = ', this.getSelectedEvent)
                    if (this.getSelectedEvent[0].type === '1') { // Live Event
                        console.log('3 -> RulesComp.vue -> joinEvent() -> this.getSelectedEvent[0].type = ', this.getSelectedEvent[0].type)
                        if (isAnonymous === '1') {
                            console.log('4 -> RulesComp.vue -> joinEvent() -> isAnonymous = ', isAnonymous)
                            setTimeout(() => {
                                // this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(res => {
                                    console.log('5 -> RulesComp.vue -> joinEvent() -> this.user.userId = ', this.user.userId)
                                    console.log('5B -> RulesComp.vue -> joinEvent() -> this.data.eventId = ', this.data.eventId)
                                    if (this.getUserEvents) {
                                        let uEvent = this.getUserEvents.filter(ev => {
                                            // return ev.eventId === this.getSelectedEvent[0].eventId   // commented on 12/02/2021 for chatroll issue
                                            return ev.eventId === this.data.eventId
                                        })
                                        console.log('6 -> RulesComp.vue -> joinEvent() -> uEvent = ', uEvent)
                                        uEvent[0].isAnonymous = '1'
                                        uEvent[0].firstName = this.user && this.user.corporation && this.user.corporation.showShoeMotif === 2 ? 'Incognito' : 'Shoe-cognito'
                                        uEvent[0].picture = this.user && this.user.corporation && this.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile.png' : this.user.picture
                                        // console.log('event info', uEvent[0])
                                        // this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(() => {
                                        this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(res => {
                                            console.log('7 -> RulesComp.vue -> joinEvent() -> uEvent[0] = ', uEvent[0])
                                            if (this.getUserSignature) {
                                                console.log('8 -> RulesComp.vue -> joinEvent() -> this.getUserSignature = ', this.getUserSignature)
                                                // this.$router.push(`/liveevent/` + this.getSelectedEvent[0].eventId) // commented on 12/02/2021 for chatroll issue
                                                this.$router.push(`/liveevent/` + this.data.eventId)
                                            }
                                        }).catch(err => {
                                            console.log('7A ERROR in GENERATESIGNATUREWITHEVENT ====> err = ', err)
                                        })
                                    }
                                }).catch(err => {
                                    console.log('8A ERROR in GETUSEREVENTS ====> err = ', err)
                                })
                            }, 500)
                        } else {
                            console.log('9 -> RulesComp.vue -> joinEvent() ->')
                            // this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(() => {
                            this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(res => {
                                console.log('10 -> RulesComp.vue -> joinEvent() -> this.user.userId = ', this.user.userId)
                                if (this.getUserSignature) {
                                    console.log('11 -> RulesComp.vue -> joinEvent() -> this.getUserSignature = ', this.getUserSignature)
                                    // this.$router.push(`/liveevent/` + this.getSelectedEvent[0].eventId) // commented on 12/02/2021 for chatroll
                                    this.$router.push(`/liveevent/` + this.data.eventId)
                                }
                            }).catch(err => {
                                console.log('11A ERROR in GENERATESIGNATURE ====> err = ', err)
                            })
                        }
                    } else {
                        console.log('12 -> RulesComp.vue -> joinEvent() -> isAnonymous = ', isAnonymous)
                        if (isAnonymous === '1') { // Talk Event
                            setTimeout(() => {
                                console.log('13 -> RulesComp.vue -> joinEvent() -> isAnonymous = ', isAnonymous)
                                // this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(res => {
                                    console.log('14 -> RulesComp.vue -> joinEvent() -> this.user.userId = ', this.user.userId)
                                    console.log('14A -> RulesComp.vue -> joinEvent() -> this.data.eventId = ', this.data.eventId)
                                    if (this.getUserEvents) {
                                        let uEvent = this.getUserEvents.filter(ev => {
                                            // return ev.eventId === this.getSelectedEvent[0].eventId // commented on 12/02/2021 for chatroll issue
                                            return ev.eventId === this.data.eventId
                                        })
                                        console.log('15 -> RulesComp.vue -> joinEvent() -> uEvent[0] = ', uEvent[0])
                                        uEvent[0].isAnonymous = '1'
                                        uEvent[0].firstName = this.user && this.user.corporation && this.user.corporation.showShoeMotif === 2 ? 'Incognito' : 'Shoe-cognito'
                                        uEvent[0].picture = this.user && this.user.corporation && this.user.corporation.showShoeMotif === 2 ? 'https://s3.amazonaws.com/assets.tonenetworks.com/images/resources/genericProfile.png' : this.user.picture
                                        // console.log('event info', uEvent[0])
                                        // this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(() => {
                                        this.$store.dispatch('GENERATESIGNATUREWITHEVENT', uEvent[0]).then(res => {
                                            console.log('16 -> RulesComp.vue -> joinEvent() -> GENERATESIGNATUREWITHEVENT')
                                            if (this.getUserSignature) {
                                                console.log('17 -> RulesComp.vue -> joinEvent() -> this.getUserSignature = ', this.getUserSignature)
                                                console.log('17A -> RulesComp.vue -> joinEvent() -> this.data.eventId = ', this.data.eventId)
                                                // this.$router.push(`/talk/` + this.getSelectedEvent[0].eventId) // commented on 12/02/2021 for chatroll issue
                                                this.$router.push(`/talk/` + this.data.eventId)
                                            }
                                        }).catch(err => {
                                            console.log('17B ERROR in GENERATESIGNATUREWITHEVENT ====> err = ', err)
                                        })
                                    }
                                }).catch(err => {
                                    console.log('17C ERROR in GETUSEREVENTS ====> err = ', err)
                                })
                            }, 500)
                        } else {
                            // this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(() => {
                            this.$store.dispatch('GENERATESIGNATURE', this.user.userId).then(res => {
                                console.log('18 -> RulesComp.vue -> joinEvent() -> this.user.userId = ', this.user.userId)
                                if (this.getUserSignature) {
                                    console.log('19 -> RulesComp.vue -> joinEvent() -> this.getUserSignature = ', this.getUserSignature)
                                    console.log('19A -> RulesComp.vue -> joinEvent() -> this.data.eventId = ', this.data.eventId)
                                    // this.$router.push(`/talk/` + this.getSelectedEvent[0].eventId)  // commented on 12/02/2021 for chatroll issue
                                    this.$router.push(`/talk/` + this.data.eventId)
                                }
                            }).catch(err => {
                                console.log('19A ERROR in GENERATESIGNATURE ====> err = ', err)
                            })
                        }
                        console.log('20 -> RulesComp.vue -> joinEvent() -> COMPLETED')
                    }
                }
            },
            returnEasternTime () {
                let offset = -5
                if (dateHelpers.dstEnabled(new Date())) {
                    offset = -4.0
                }
                let clientDate = new Date()
                let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
                let serverDate = new Date(utc + (3600000 * offset))
                return serverDate
            },
            getDateReference (dte, type) {
                let dt = new Date(dte)
                let dayStr, monStr
                let eDay = dt.getDate()
                let eHours = this.getHoursFormatted(dt)
                let eMonth = dt.getMonth() + 1
                let day
                // Set Day of Date
                if (dt.getDay() === 0) {
                    day = 'Sunday'
                } else if (dt.getDay() === 1) {
                    day = 'Monday'
                } else if (dt.getDay() === 2) {
                    day = 'Tuesday'
                } else if (dt.getDay() === 3) {
                    day = 'Wednesday'
                } else if (dt.getDay() === 4) {
                    day = 'Thursday'
                } else if (dt.getDay() === 5) {
                    day = 'Friday'
                } else if (dt.getDay() === 6) {
                    day = 'Saturday'
                } else {
                    day = ''
                }
                // Set Date Pattern
                if (eDay === 1) {
                    dayStr = '1st'
                } else if (eDay === 2) {
                    dayStr = '2nd'
                } else if (eDay === 3) {
                    dayStr = '3rd'
                } else if (eDay === 21) {
                    dayStr = '21st'
                } else if (eDay === 22) {
                    dayStr = '22nd'
                } else if (eDay === 23) {
                    dayStr = '23rd'
                } else if (eDay === 31) {
                    dayStr = '31st'
                } else {
                    dayStr = eDay + 'th'
                }
                // Set Month
                if (eMonth === 1) {
                    monStr = 'January'
                } else if (eMonth === 2) {
                    monStr = 'February'
                } else if (eMonth === 3) {
                    monStr = 'March'
                } else if (eMonth === 4) {
                    monStr = 'April'
                } else if (eMonth === 5) {
                    monStr = 'May'
                } else if (eMonth === 6) {
                    monStr = 'June'
                } else if (eMonth === 7) {
                    monStr = 'July'
                } else if (eMonth === 8) {
                    monStr = 'August'
                } else if (eMonth === 9) {
                    monStr = 'September'
                } else if (eMonth === 10) {
                    monStr = 'October'
                } else if (eMonth === 11) {
                    monStr = 'November'
                } else if (eMonth === 12) {
                    monStr = 'December'
                }
                if (type === 'btn') {
                    return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
                } else if (type === 'live') {
                    return monStr + ' ' + eDay
                } else if (type === 'live2') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else if (type === 'str') {
                    return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
                } else {
                    return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
                }
            },
            isEventToday (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
                let eventDate = new Date(evtDate)
                let currentDate = this.returnEasternTime()
                let eventEndDate = new Date(endDate)
                let switchTime = parseInt(defaultSwitchTime)
                if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                    switchTime = parseInt(eventSwtichTime)
                }
                // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
                if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                    if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            },
            getMinutesBetweenDates (startDate, endDate) {
                var diff = endDate.getTime() - startDate.getTime()
                return (diff / 60000)
            },
            updateUserStatus (status) {
                // Get event from User Events
                // this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(() => {
                this.$store.dispatch('GETUSEREVENTS', this.user.userId).then(res => {
                    if (this.getUserEvents) {
                        let uEvent = this.getUserEvents.filter(ev => {
                            // return ev.eventId === this.getSelectedEvent[0].eventId // commented on 12/02/2021 for chatroll issue
                            console.log('1 -> updateUserStatus -> this.data.eventId = ', this.data.eventId)
                            return ev.eventId === this.data.eventId
                        })
                        if (uEvent && uEvent.length > 0) {
                            // this.seatReservation.eventId = this.getSelectedEvent[0].eventId // commented on 12/02/2021 for chatroll issue
                            console.log('2 -> updateUserStatus -> this.data.eventId = ', this.data.eventId)
                            this.seatReservation.eventId = this.data.eventId
                            this.seatReservation.userId = this.user.userId
                            this.seatReservation.status = '2'
                            this.seatReservation.isAnonymous = status
                            this.seatReservation.userEventId = uEvent[0].userEventId
                            this.$store.dispatch('UPDATERESERVATION', this.seatReservation).then(() => {
                            })
                        } else {
                            // this.seatReservation.eventId = this.getSelectedEvent[0].eventId // commented on 12/02/2021 for chatroll issue
                            console.log('3 -> updateUserStatus -> this.data.eventId = ', this.data.eventId)
                            this.seatReservation.eventId = this.data.eventId
                            this.seatReservation.userId = this.user.userId
                            this.seatReservation.status = '2'
                            this.seatReservation.isAnonymous = status
                            this.$store.dispatch('SEATRESERVATION', this.seatReservation).then(() => {
                            })
                        }
                    }
                }).catch(err => {
                    console.log('ERROR in -> updateUserStatus ->  GETUSEREVENTS ====> err = ', err)
                })
            },
            getHoursFormatted (time) {
                let hours = time.getHours()
                let minutes = time.getMinutes()
                let ampm = hours >= 12 ? 'pm' : 'am'
                hours = hours % 12
                hours = hours === 0 ? '12' : hours
                minutes = minutes < 10 ? '0' + minutes : minutes
                let strTime = hours + ':' + minutes + ' ' + ampm
                return strTime
            }
        },
        mounted: function () {
            let self = this
            self.eventRef = this.data
            /*
            this.$store.dispatch('getUserInfo').then(res => {
                this.$router.push('/index');
            }).catch( err => {
                console.log(err);
            })
            */
            // https://developpaper.com/question/how-to-make-this-store-dispatch-asynchronous-function-execute-synchronously-in-vue-that-is-to-register-and-retrieve-user-information-before-jumping/
            if (self.getTrialDays < 0) {
                self.$router.push('/becomemember')
            } else {
                if (self.user && self.user.corporation && self.user.corporation.showShoeMotif === 2) {
                    self.cognitoMsg = 'incognito'
                } else {
                    self.cognitoMsg = 'shoe-cognito'
                }
                if (self.eventRef.eventId > 0) {
                    // self.$store.dispatch('GETSELECTEDEVENT', self.eventRef.eventId).then(() => {
                    self.$store.dispatch('GETSELECTEDEVENT', self.eventRef.eventId).then(res => {
                        if (self.getSelectedEvent) {
                            self.$store.dispatch('GETEXPERT', self.getSelectedEvent[0].expertId).then(() => {
                            })
                            if (self.user) {
                                self.$store.dispatch('GETUSEREVENTS', self.user.userId).then(() => {}).catch(err => {
                                    console.log('ERROR in GETUSEREVENTS ====> err = ', err)
                                })
                            }
                        } else {
//                            this.$router.push(`/event`)
                        }
                    }).catch(err => {
                        console.log('ERROR in GETSELECTEDEVENT ====> err = ', err)
                    })
                } else {
//                    this.$router.push(`/event`)
                }
            }
            if (self.getCorporateGiftInfo && self.getCorporateGiftInfo.button_label_01) {
                self.trialButtonTitle = self.getCorporateGiftInfo.button_label_01
            }
        },
        computed: {
            ...mapGetters([
                'user', 'getExpert', 'getSelectedEvent', 'getUserEvents', 'getUserSignature', 'getUserStatus', 'getTrialDays', 'getEventSwitchTime', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor', 'getCorporateGiftInfo']
            ),
            styleObjectByName () {
                if (this.hoverState) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor,
                        borderColor: this.getCorpButtonColor
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: this.getCorpButtonColor
                        // borderColor: this.getCorpButtonColor
                    }
                }
            },
            styleObjectCognito () {
                if (this.hoverStateCog) {
                    return {
                        color: '#FFFFFF',
                        backgroundColor: this.getCorpButtonColor,
                        borderColor: this.getCorpButtonColor
                    }
                } else {
                    return {
                        // border: '2px solid' + this.getCorpButtonColor + ' !important',
                        color: this.getCorpButtonColor,
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: this.getCorpButtonColor
                        // borderColor: this.getCorpButtonColor
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .container .rules-expert-content img {
        width: 160px;
        height: 160px;
        display: block;
        margin: 0 auto 25px;
        border-radius: 50%;
    }
    .container .marginTop .ruleImages p {
        text-align: left;
        color: #000000;
        font-family: sans-serif;
        padding: 0 0 0 30px;
        line-height: 1.2;
        margin: 0;
        position: absolute;
    }
    @media(min-width:993px){
        .rules-banner{
            height: auto;
            min-height: 582px;
            padding-bottom: 80px;
        }
    }
    button.sigup-green-join-button {
        font-family: 'Montserrat', sans-serif !important;
        padding: 10px 16px;
        font-size: 18px;
        line-height: 1.33333;
        border-radius: 6px;
        color: #fff;
        background-color: #5cb85c;
        border-color: #4cae4c;
    }
    button.sigup-green-join-button:hover {
        color: #fff;
        background-color: #449d44;
        border-color: #398439;
    }
</style>



// WEBPACK FOOTER //
// RulesComp.vue?ce6ff722